import React, { Fragment } from 'react';
import { Item, Grid, List, Card, Divider } from 'semantic-ui-react';
import InformationItem from '../../../InformationItem';
import { dateFormat } from '../../../../utils/dateFormat';

const Amicable = ({
  crmState,
  paxCompensationAmount,
  maximumCompensationAmount,
  refundFromAirlineDate,
  refundFromAirlineAmount,
  paxToTransferAmount
}) => {
  const setFieldValue = value => (value || value === 0 ? value : '');
  return (
    <Fragment>
      <Divider />
      <Item>
        <Item.Content>
          <Item.Header>Amicable</Item.Header>
          <Divider hidden />
          <Card fluid>
            <Card.Content>
              <Grid>
                <Grid.Row columns={2} divided>
                  <Grid.Column>
                    {crmState.startsWith('b4') && (
                      <Fragment>
                        <List>
                          <InformationItem
                            icon='money'
                            content={setFieldValue(paxCompensationAmount)}
                            info='Pax Compensation Amount'
                          />
                          <InformationItem
                            icon='user'
                            content={setFieldValue(maximumCompensationAmount)}
                            info='Standard Compensation Amount'
                          />
                        </List>
                      </Fragment>
                    )}
                  </Grid.Column>
                  <Grid.Column>
                    {crmState === 'b5_pax_to_refund' && (
                      <Fragment>
                        <List>
                          <InformationItem
                            icon='calendar outline'
                            content={setFieldValue(
                              dateFormat(refundFromAirlineDate)
                            )}
                            info='Refund From Airline Date'
                          />
                          <InformationItem
                            icon='money'
                            content={setFieldValue(refundFromAirlineAmount)}
                            info='Refund From Airline Amount'
                          />
                          <InformationItem
                            icon='user'
                            content={setFieldValue(paxToTransferAmount)}
                            info='Pax To Transfer Amount'
                          />
                        </List>
                      </Fragment>
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Card.Content>
          </Card>
        </Item.Content>
      </Item>
    </Fragment>
  );
};

export default Amicable;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Amicable/index.js